import script from "./FieldValueWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldValueWrapper.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__